export default "__VITE_ASSET__TDxNQ5P7__"